import React from 'react';
import { usePopmenuConfig } from '~/eat/hooks/usePopmenuConfig';
import { useRouteParams } from '../../hooks/useRouteParams';
import { DishFeedScroller } from '../DishFeedScroller';
import { DishFeedTitle } from '../DishFeedTitle';

export const DishFeedPage = () => {
  const { env } = usePopmenuConfig();
  const defaultPlaceSlug = env === 'development' ? 'global' : 'atlanta-ga';
  const routePlaceSlug = useRouteParams().placeSlug;
  const placeSlug = routePlaceSlug || defaultPlaceSlug;
  const isHomePage = !routePlaceSlug;

  return (
    <React.Fragment>
      <DishFeedTitle
        isHomePage={isHomePage}
        placeSlug={placeSlug}
      />
      <DishFeedScroller
        dishPathPrefix={`/places/${placeSlug}`}
        placeSlug={placeSlug}
      />
    </React.Fragment>
  );
};
